import { ApplicationConfig } from '@angular/core';
import { BASE_PATH as ASSESSMENT_SERVICE_BASE_PATH } from 'src/generated/api/assessment-service';
import { environment } from 'src/main/environments';

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: ASSESSMENT_SERVICE_BASE_PATH,
      useValue: environment.assessmentServiceUrl,
    },
  ],
};
